export default __webpack_public_path__ + "static/media/img_9.8fb4e82e.jpg";